// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentRequest {
    static getAttributeTypeMap() {
        return EnrollmentRequest.attributeTypeMap;
    }
}
EnrollmentRequest.discriminator = undefined;
EnrollmentRequest.additionalProperties = false;
EnrollmentRequest.attributeTypeMap = [
    {
        "name": "patient",
        "baseName": "patient",
        "type": "Patient"
    },
    {
        "name": "medicalPayors",
        "baseName": "medicalPayors",
        "type": "Array<MedicalPayor>"
    },
    {
        "name": "pharmacyPayors",
        "baseName": "pharmacyPayors",
        "type": "Array<PharmacyPayor>"
    },
    {
        "name": "pharmacies",
        "baseName": "pharmacies",
        "type": "Array<Pharmacy>"
    },
    {
        "name": "prescribers",
        "baseName": "prescribers",
        "type": "Array<Prescriber>"
    },
    {
        "name": "prescriptions",
        "baseName": "prescriptions",
        "type": "Array<Prescription>"
    },
    {
        "name": "sites",
        "baseName": "sites",
        "type": "Array<Site>"
    },
    {
        "name": "surveys",
        "baseName": "surveys",
        "type": "Array<Survey>"
    },
    {
        "name": "diagnosisCodes",
        "baseName": "diagnosisCodes",
        "type": "Array<string>"
    },
    {
        "name": "enrollmentPaymentType",
        "baseName": "enrollmentPaymentType",
        "type": "EnrollmentApiPaymentType"
    },
    {
        "name": "thirdPartyCaseId",
        "baseName": "thirdPartyCaseId",
        "type": "string"
    },
    {
        "name": "thirdPartyEnrollmentId",
        "baseName": "thirdPartyEnrollmentId",
        "type": "string"
    },
    {
        "name": "caseInitiator",
        "baseName": "caseInitiator",
        "type": "EnrollPatientCaseInitiator"
    },
    {
        "name": "caseSource",
        "baseName": "caseSource",
        "type": "EnrollPatientCaseSource"
    },
];
//# sourceMappingURL=enrollmentRequest.js.map